import React from 'react';
import Navbar from '../Navbar';
import { Col, Container, Row, Modal } from 'react-bootstrap';
import Input from '../Input';
import ForwardArrow from '../../Assets/forward-arrow.svg';
import { hideLoader, showLoader } from '../../util/loader/CustomLoader';
import DevAuthAPI from '../../api/DevAuth';
import { CustomToast } from '../../util/custom-toast/CustomToast';
import Close from "../../Assets/close.svg";
import { Link } from "react-router-dom";

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: { value: '', warning: { msg: '', class: '' } },
        };
    }

    validateEmail(email) {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    sendResetLink() {
        if (!this.validateEmail(this.state.email.value)) {
            var tempState = { ...this.state.email };

            tempState.warning = {
                msg: 'Invalid Email',
                class: 'border-red red',
            };
            this.setState({ email: tempState });
            return;
        }
        showLoader();
        var api = new DevAuthAPI();
        api.forgotPassword({ email: this.state.email.value })
            .then((response) => {
                hideLoader();
                CustomToast(
                    'Please check your email to change password : Attempt 1'
                );
                this.props.history.push(
                    '/reset-link?email=' + this.state.email.value
                );
            })
            .catch((error) => {
                hideLoader();

                CustomToast(error.response.data.message);
            });
    }

    render() {
        return (
            <React.Fragment>
                <Navbar showSignup={true} />
                <Container fluid className="main-container">
                    <Modal
                        show={true}
                        centered
                        contentClassName="login-modal p-2"
                    >
                        <Modal.Body className="pb-0">
                            <Container>
                                <Row>
                                <div className="d-flex d-justify-sb pl-0">
                                            <div>
                                                <h4>
                                                    Forgot Password ?
                                                </h4>
                                            </div>
                                            <div>
                                                <span>
                                                    <Link to="/">
                                                        <img src={Close} height="14" width="14" alt="cross" />
                                                    </Link>
                                                </span>
                                            </div>
                                        </div>
                                    <Col xs={10} md={11} className="px-0">
                                        <h1
                                            style={{
                                                fontFamily: 'JioType-Medium',
                                                color: '#7B7B7B',
                                                fontSize: '14px',
                                            }}
                                            className="sub-title"
                                        >
                                            Enter the email address you used
                                            when you joined and we’ll send you
                                            link to reset your password.
                                        </h1>
                                    </Col>
                                    <Col xs={2} md={1} className="px-0 "></Col>
                                </Row>
                                
                                <Row>
                                    <Col xs={12} md={12} className="px-0">
                                        <Input
                                            required
                                            label="Email ID"
                                            type="email"
                                            name="email"
                                            warning={this.state.email.warning}
                                            value={this.state.email.value}
                                            onChange={(e) => {
                                                var tempState = {
                                                    ...this.state.email,
                                                };
                                                tempState.value =
                                                    e.target.value;
                                                if (
                                                    this.validateEmail(
                                                        e.target.value
                                                    ) ||
                                                    e.target.value.length === 0
                                                )
                                                    tempState.warning = {
                                                        msg: '',
                                                        class: '',
                                                    };
                                                else
                                                    tempState.warning = {
                                                        msg: 'Invalid Email',
                                                        class: 'border-red red',
                                                    };
                                                this.setState({
                                                    email: tempState,
                                                });
                                            }}
                                            style={{ marginBottom: '-5px' }}
                                        />
                                    </Col>

                                    <div className="d-flex d-justify-center">
                                        <span onClick={(e) => this.sendResetLink()}
                                        className="link c-pointer">
                                        Send Reset Link
                                        <img
                                            alt=""
                                            class="m-1"
                                            src={ForwardArrow}
                                            height="12"
                                            width="13"
                                            marginTop="-2px"
                                        />
                                        </span>
                                    </div>
                                </Row>
                            </Container>
                        </Modal.Body>
                    </Modal>
                </Container>
            </React.Fragment>
        );
    }
}

export default ForgotPassword;
